<template>
  <body>  

     
    <div id="content">
      <iframe src="https://analytics.blubirch.com/home/#/opendocument?data=eyJ1c2VyIjoiMzI3NzUiLCJzcGFjZWtleSI6IjExMTEiLCJkb2NJZCI6IjM2NzAxMDYiLCJhbGciOiJIUzI1NiIsInppcCI6IkdaSVAifQ.H4sIAAAAAAAAADWQy3KCMABF_4V1xxFiEugOBCSQNAqDMu4ggKCVhxFEnf576aJnd-ds7py3cr7XyqcCNIyh8qHIIZtX8fSrbCNqXvskfhH1qyaSNF0n1gSRS55Ge7MudwtvJYn5j6Ux_kA2s0wXY6JOCZR571Iyyji7To9TFLjR-uhWtMI3OvXHtgO72V25yyTHVE9AYtlsWxrj4XUmvdMiw9sOr7Hp_IczSXuKS8fk0W7i_uZEYaFHWTh0VDDHPGij0bDxsjdv2TdlgEVbfw1ujUqHoG9sw-T-_dkfvL-bi7MV24GmDuPyGsCmuQdID91kY7hhm4ewzYajVnh6lZ4yMfeopZx7IFFiZACEVkKANC1VhAVa6lAVhQFBDpWfXzgnq2tIAQAA.oaY-EIF3By1wVZcsV_EV9xiAH19s2Uo8QRR7ihkk_sE"></iframe>
    </div>


</body>
</template>


<script>

  export default {
    name: 'sellerDashboard'
  }

</script>

<style media="screen" scoped>

iframe {

  border: none;
  height: 100vh;       
  width: 95vw;
  margin-left: -8px;
}
</style>


// WEBPACK FOOTER //
// src/components/api/v1/warehouse/dashboards/sellerDashboard.vue